<template>
	<div>
		<article>
			<h1>{{$t("utilityComponents.notAvailable.websiteUnavailable")}}</h1>
			<div class="body">
				<p>{{$t("utilityComponents.notAvailable.sorryMessage")}}</p>
			</div>
		</article>
	</div>
</template>

<script>
	export default {
		name: "NotAvailable",
		data() {
			return {};
		}
	};
</script>

<style scoped>
	body {
		text-align: center;
		padding: 150px;
	}

	h1 {
		font-size: 50px;
	}

	body {
		font: 20px Helvetica, sans-serif;
		color: #333;
	}

	article {
		display: block;
		text-align: left;
		width: 650px;
		margin: 40px auto 0;
	}

	h1 {
		color: #ffffff;
		text-align: center;
	}

	div.body {
		margin-top: 40px;
	}

	div.body p {
		color: #ffffff;
	}
</style>

